export const official = {
  D: {
    type: "D型 支配型/控制者",
    desc:
      "描述性词语：积极进取、争强好胜、强势、爱追根究底、直截了当、主动的开拓者、坚持意见、自信、直率",
    characterDesc:
      "高D型特质的人可以称为是“天生的领袖”。这种类型是一个坚定果敢的人，酷好变化，喜欢控制，干劲十足，独立自主，超级自信。可是，由于比较不会顾及别人的感受，所以显得粗鲁、霸道、没有耐心、穷追不舍、不会放松。这种类型的人不习惯与别人进行感情上的交流，不会恭维人，不喜欢眼泪，匮乏同情心。",
    jobDesc:
      "在工作方面，这种类型的人是一个务实和讲究效率的人，目标明确，眼光全面，组织力强，行动迅速，解决问题不过夜，果敢坚持到底，在反对声中成长。但是，因为过于强调结果， 这种类型的人往往容易忽视细节，处理问题不够细致。爱管人、喜欢支使他人的特点使得这种类型的人能够带动团队进步，但也容易激起同事的反感。",
    interpersonalDesc:
      "在人际关系方面， 这种类型的人喜欢为别人做主，虽然这样能够帮助别人做出选择，但也容易让人有强迫感。由于关注自己的目标，这种类型的人在乎的是别人的可利用价值。喜欢控制别人，不会说对不起。"
  },
  I: {
    type: "I型 活跃型/社交者",
    desc:
      "描述性词语：有影响力、有说服力、友好、善于言辞、健谈、乐观积极、善于交际",
    characterDesc:
      "高I型的人通常是较为活泼的团队活动组织者。这种类型是一个情感丰富而外露的人，由于性格活跃，爱说，爱讲故事，幽默，彩色记忆，能抓住听众，你常常是聚会的中心人物。是一个天才的演员，天真无邪，热情诚挚，喜欢送礼和接受礼物，看重人缘。情绪化的特点使得你容易兴奋，喜欢吹牛、说大话，天真，永远长不大，富有喜剧色彩。但是，似乎也很容易生气，爱抱怨，大嗓门，不成熟。",
    jobDesc:
      "在工作方面，这种类型的人是一个热情的推动者，总有新主意，色彩丰富，说干就干，能够鼓励和带领他人一起积极投入工作。可是，这种类型的人似乎总是情绪决定一切，想哪儿说哪儿，而且说得多干得少，遇到困难容易失去信心，杂乱无章，做事不彻底，爱走神儿，爱找借口。喜欢轻松友好的环境，非常害怕被拒绝。",
    interpersonalDesc:
      "在人际关系方面，这种类型的人容易交上朋友，朋友也多。关爱朋友，也被朋友称赞。爱当主角，爱受欢迎喜欢控制谈话内容。可是，喜欢即兴表演的特点使得这种类型的人常常不能仔细理解别人，而且健忘多变。 "
  },
  S: {
    type: "S型 支持型/协助者",
    desc:
      "描述性词语：可靠、深思熟虑、亲切友好、有毅力、坚持不懈、善倾听者、全面周到、自制力强",
    characterDesc:
      "高S型的人通常较为平和，知足常乐，不愿意主动前进。这种类型是一个温和主义者，悠闲，平和，有耐心，感情内藏，待人和蔼，乐于倾听，遇事冷静，随遇而安。这种类型的人喜欢使用一句口头禅：“不过如此。”这个特点使得这种类型的人总是缺乏热情，不愿改变。",
    jobDesc:
      "在工作方面，这种类型的人能够按部就班地管理事务，胜任工作并能够持之以恒。奉行中庸之道，平和可亲，一方面习惯于避免冲突，另一方面也能处变不惊。但是，这种类型的人似乎总是慢吞吞的，很难被鼓动，懒惰，马虎，得过且过。由于害怕承担风险和责任，宁愿站在一边旁观。很多时候，这种类型的人总是焉有主意，有话不说，或折衷处理。",
    interpersonalDesc:
      "在人际关系方面，这种类型的人是一个容易相处的人，喜欢观察人、琢磨人，乐于倾听，愿意支持。可是，由于不以为然，这种类型的人也可能显得漠不关心，或者嘲讽别人。"
  },
  C: {
    type: "C型 严谨型/稳健者",
    desc: "描述性词语：遵从、仔细、有条不紊、严谨、准确、完美主义者、逻辑性强",
    characterDesc:
      "高C型的人通常是喜欢追求完美的专业型人才。这种类型是一个性格深沉的人，严肃认真，目的性强，善于分析，愿意思考人生与工作的意义，喜欢美丽，对他人敏感，理想主义。但是，这种类型的人总是习惯于记住负面的东西，容易情绪低落，过分自我反省，自我贬低，离群索居，有忧郁症倾向。",
    jobDesc:
      "在工作方面，这种类型的人是一个完美主义者，高标准，计划性强，注重细节，讲究条理，整洁，能够发现问题并制订解决问题的办法，喜欢图表和清单，坚持己见，善始善终。但是，这种类型的人也很可能是一个优柔寡断的人，习惯于收集信息资料和做分析，却很难投入到实际运作的工作中来。容易自我否定，因此需要别人的认同。同时，也习惯于挑剔别人，不能忍受别人的工作做不好。",
    interpersonalDesc:
      "在人际关系方面，这种类型的人一方面在寻找理想伙伴，另一方面却交友谨慎。能够深切地关怀他人，善于倾听抱怨，帮助别人解决困难。但是，这种类型的人似乎始终有一种不安全感，以致于感情内向，退缩，怀疑别人，喜欢批评人事，却不喜欢别人的反对。"
  }
};
